///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store = abcsetup.front_store || {};
abcsetup.front_store.create = abcsetup.front_store.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.create.removeButtons = [];
abcsetup.front_store.create.removeButtonsDisplay = [];
abcsetup.front_store.create.removeButtonsFieldTeam = [];
abcsetup.front_store.create.itemTimeout = null;
abcsetup.front_store.create.front_store_id = 0;
abcsetup.front_store.create.display_items = [];
abcsetup.front_store.create.one_ws_item = [];
abcsetup.attachments.width = null;
abcsetup.attachments.height = null;

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.create = {
    init: function () {
        abcsetup.setTitle('Add Consumer Item');
        abcsetup.front_store.create.removeButtons = ['maintenance_approve_screenshot', 'sap_pricing_letter', 'ahp_pricing_letter', 'mwi_pricing_letter'];
        abcsetup.front_store.create.removeButtonsDisplay = ['flat_product_bar_code_image', 'pr_registration_doc'];
        abcsetup.front_store.create.removeButtonsFieldTeam = ['spec_sheet', 'front_panel_product_image', 'case_label', 'flat_product_bar_code_image'];

        abcsetup.attachments.width = $(window).width() - 200;
        abcsetup.attachments.height = $(window).height() - 100;

        abcsetup.form_manager.form = $('form.front-store-item');
        // Init any field restrictions/values
        this._initFields();

        // Init the SAP Divisions
        this._initSAPDiv();

        // Init the attachment buttons
        this._initAttachments();

        // Delete attachment button clicked
        $(document).on('click', '.delete-attachment', function (event) {
            event.preventDefault();
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Attachment', 'Are you sure you want to delete this attachment?', function (resp) {
                if (resp) {
                    _this.parent().fadeOut('slow', function () {
                        $(this).remove();

                        // Auto save the item form
                        //abcsetup.front_store.edit._autoSave();
                        $('button#' + _this.attr("id")).addClass('required btn-danger').show();
                    });
                }
            });
        });

        // Show the add item modal
        $('#add-btn').click(function() {
            abcsetup.front_store.create.addItem();
        });

        // Show the 1ws modal
        $('#onews-btn').click(function() {
            console.log('abcsetup.orgOneWs',abcsetup.orgOneWs.one_ws_cis.length);

            var registered = false;
            if (abcsetup.orgOneWs.one_ws_cis.length > 0) {
                $(abcsetup.orgOneWs.one_ws_cis).each(function() {
                    if (this.state == 'active') {
                        registered = true;
                        return false;
                    }
                });
            }

            if (registered) {
                abcsetup.front_store.create.oneWs();
            } else {
                abcsetup.alerts.confirm('1WorldSync Registration', 'Sorry! You haven\'t registered with 1WorldSync yet. To register, please go to <a href="https://www.abcsetup.com/1ws_cis/index" target="_blank">1WorldSync Registration</a> and enter your GLN to get started. Please contact support@cencorasupplierportal.com for any questions.');
            }
        });

        if (abcsetup.userRole.class == 'vendor'){
            $(document).on('change', '#has_image', function() {
                abcsetup.toggleRequired(document.querySelector('input[data-idx=primary_glamour_shot]'), (document.getElementById('has_image').value == 'Y'));
            });
        }


        $("#item_gtin").change(function(e){
            var item_gtin = $(this).val();
            if (item_gtin.length == 14) {
                axios.get('/api/one_ws/search?column=gtin&value=' + item_gtin).then(response => {
                    if (response.data.length) {
                        $('#onews-btn').trigger('click');
                    }
                });
            }
         });

        // Relink button clicked
        $(document).on('click', '.btn.btn-link', function (e) {
            abcsetup.front_store.create.linkItem($(this).data('id'));
            $(this).addClass("btn-danger").attr('disabled', true);
        });

        $('table.new_display_items_table .btn-options input:checked').trigger('change');

        // Item modal hidden
        $('#item-modal').on('hidden.bs.modal', function (e) {
            $('#item-modal').find('#results').data('searchString', '');
        });

        // Item modal field(s) changed
        $('#item-modal input, #item-modal select').bind('change keyup', function() {
            clearTimeout(abcsetup.front_store.create.itemTimeout);

            abcsetup.front_store.create.itemTimeout = setTimeout(function() {
                abcsetup.front_store.create.findItems();
            }, 500);
        });

        // Relink button clicked
        $(document).on('click', '.btn.btn-populate', function (e) {
            abcsetup.front_store.create.populateForm($(this).data('id'));
        });

        // OneWs modal hidden
        $('#onews-modal').on('hidden.bs.modal', function (e) {
            $('#onews-modal').find('#results').data('searchString', '');
        });

        // Item modal field(s) changed
        $('#onews-modal input').bind('change keyup', function() {
            clearTimeout(abcsetup.front_store.create.itemTimeout);

            abcsetup.front_store.create.itemTimeout = setTimeout(function() {
                abcsetup.front_store.create.findOneWsItem();
            }, 500);
        });

        // Remove item button clicked
        $(document).on('click', '.btn.btn-remove-item', function (e) {
            let abcItemId = $(this).val();
            $(this).closest('tr').fadeOut('slow', function() {
                $(this).remove();
                abcsetup.front_store.create.updateDisplayTotals();
                abcsetup.front_store.create.updateDisplayUniqueItems();
                abcsetup.front_store.create.deleteDisplayItemAttachment(abcItemId);
            });
        });

        // Calculate total wac
        $(document).on('change', '.qty', function() {
            var qty = $(this).val();
            var wac_per_item = parseFloat($(this).closest("tr").find(".wac_per_item").html());
            var wac_total = qty*wac_per_item;
            $(this).closest("tr").find(".wac_total").html(wac_total.toFixed(2));

            abcsetup.front_store.create.updateDisplayTotals();
        });

        // Hide by default
        $('.food-products-other-description').hide().val('');

        // Food Products other checked
        $(document).on('click', '.food-products-other', function (e) {
            if ($(this).is(':checked')) {
                $('.food-products-other-description').show().val('');
                $('.food-products').not(this).prop('disabled', true).prop('checked', false);
            } else {
                $('.food-products-other-description').hide().val('');
                $('.food-products').prop('disabled', false);
            }
        });

        $(document).on('change', '#product_regulated_cfr', function() {
            if ($(this).val() == 'N' || $(this).val() == '') {
                $('#hazmat_id_cfr').val('');
                $('#un_id_cfr').val('');
                $('#hazard_class_cfr').val('');
                $('#pack_group_cfr').val('');
                $('#shipping_name_1_cfr').val('');
                $('#label_code_cfr').val('');
                $('#qty_limit_par_cfr').val('');
                $('#qty_limit_cao_cfr').val('');
                $('#vessel_stowage_location_cfr').val('');
                $('#vessel_stowage_other_cfr').val('');
            }
        });

        $(document).on('change', '#product_regulated_iata', function() {
            if ($(this).val() == 'N' || $(this).val() == '') {
                $('#hazmat_id_iata').val('');
                $('#un_id_iata').val('');
                $('#shipping_name_iata').val('');
                $('#descr_iata').val('');
                $('#pack_group_iata').val('');
            }
        });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // Note: all front store form related JS is handled in the global /forms/_front_store_item.js form namespace
        abcsetup.front_store.form.init();
    },

    /**
     * Init any field restrictions/values
     */
    _initFields: function () {
        require('./_common_rules');
    },

    /**
     * Init the SAP divisions
     */
    _initSAPDiv: function () {
        require('./_sap_divisions');
    },

    /**
     *
     */
    _initAttachments: function () {
        $(abcsetup.front_store.create.removeButtons).each(function () {
            $('button#' + this).remove();
            $('input[data-idx="' + this + '"]').remove();
        });

        if ($("#type").val() == 'display') {
            $(abcsetup.front_store.create.removeButtonsDisplay).each(function() {
                $('button#' + this).remove();
                $('input[data-idx="' + this + '"]').remove();
            });
        }
        else {
            $('button#outside_shipping_carton_label').remove();
            $('input[data-idx="outside_shipping_carton_label"]').remove();
        }

        if (abcsetup.userRole.class == 'field_team') {
            $(abcsetup.front_store.create.removeButtonsFieldTeam).each(function() {
                $('button#' + this).remove();
                $('input[data-idx="' + this + '"]').remove();
            });
        }

        // Manually apply showIf rules to buttons and their input fields
        $('button#sds_waiver, input[data-idx="sds_waiver"]').attr('showIf', 'sds_waiver=N');
        abcsetup.fieldLib.bindElement($('button#sds_waiver, input[data-idx="sds_waiver"]'), 'showIf');

        $('button#msds_sheet, input[data-idx="msds_sheet"]').attr('showIf', 'sds_waiver=Y');
        abcsetup.fieldLib.bindElement($('button#msds_sheet, input[data-idx="msds_sheet"]'), 'showIf');

        $('button#flat_product_bar_code_image, input[data-idx="flat_product_bar_code_image"]').attr('requiredIf', 'gnp=N');
        abcsetup.fieldLib.bindElement($('button#flat_product_bar_code_image, input[data-idx="flat_product_bar_code_image"]'), 'requiredIf');

        if ($("#type").val() == 'display') {
            $('button#outside_shipping_carton_label, input[data-idx="outside_shipping_carton_label"]').attr('showIf', 'type=display');
            abcsetup.fieldLib.bindElement($('button#outside_shipping_carton_label, input[data-idx="outside_shipping_carton_label"]'), 'showIf');
        }
        else {
            $("button#outside_shipping_carton_label").removeClass("required btn-danger").hide();
            $('button#pr_registration_doc, input[data-idx="pr_registration_doc"]').attr('showIf', 'eligible_sale_pr=Y');
            abcsetup.fieldLib.bindElement($('button#pr_registration_doc, input[data-idx="pr_registration_doc"]'), 'showIf');
        }
    },

    /**
     * Show the add item modal
     */
    addItem: function() {
        abcsetup.front_store.create.front_store_id = 0;
        $('#item-modal .modal-title').html('Search and Add Items to Display');
        $('#item-modal input, #item-modal select').val('');
        $('#item-modal').find('#results').html('');

        $('#item-modal').modal('show');
    },

    /**
     * Show the add item modal
     */
    oneWs: function() {
        $('#onews-modal .modal-title').html('Search 1WorldSync Items');
        $('#onews-modal').find('#results').html('');

        $('#onews-modal').modal('show');

        if ($("#item_gtin").val() != '') {
            $("#gtin").val($("#item_gtin").val()).trigger("change");
        }
    },


    /**
     *
     */
    findItems: function() {
        var identifier = $('#item-modal').find('#identifier').val();
        var mfr_prod_code = $('#item-modal').find('#mfr_prod_code').val();
        var mat_descr = $('#item-modal').find('#mat_descr').val();
        var category = $('#item-modal').find('#category').val();
        var limit_vendor = '';

        abcsetup.front_store.create.display_items = [];

        // No search params are specified
        if (identifier == '' && mfr_prod_code == '' && mat_descr == '' && category == '') {
            $('#item-modal').find('#results').data('searchString', '').html('');
            return false;
        }

        // Come up with a unique search string to prevent duplicate search
        var searchString = identifier + mfr_prod_code + mat_descr + category;
        if ($('#item-modal').find('#results').data('searchString') == searchString) {
            return false;
        }

        // Remember the unique search string
        $('#item-modal').find('#results').data('searchString', searchString);

        // We're not re-linking an item, limit the items to the current vendor
        if (abcsetup.front_store.create.front_store_id == 0) {
            limit_vendor = abcsetup.userOrg.id;
        }

        // Block the UI with a spinner
        abcsetup.blockUI(true);

        axios.get('/api/front_store/display_item_search?identifier=' + identifier + '&mfr_prod_code=' + mfr_prod_code + '&mat_descr=' + mat_descr + '&category=' + category + '&limit_vendor=' + limit_vendor).then(response => {
            abcsetup.unblockUI();

            var html = '<div class="col-12">\
                            <table class="table table-striped table-sm table-bordered table-hover">\
                                <thead>\
                                    <tr>\
                                        <th>SAP #</th>\
                                        <th>UPC</th>\
                                        <th>COR 6-Digit Item #</th>\
                                        <th>Mfg. Part Number</th>\
                                        <th>Description</th>\
                                        <th>Category</th>\
                                        <th>Mat. Status</th>\
                                        <th></th>\
                                    </tr>\
                                </thead>';

            $(response.data).each(function() {
                var row_class = '';
                var button = '';
                if (this.mat_status != 'DM' && this.mat_status != 'DB') {
                    // Check if the item already exists in the display item list
                    if ($('.item_id[value="' + this.id + '"]').length > 0) {
                        button = '<button type="button" class="btn btn-primary btn-link btn-sm btn-danger" disabled="disabled" data-id="' + this.id + '">Add</button>';
                    }
                    else {
                        button = '<button type="button" class="btn btn-primary btn-link btn-sm" data-id="' + this.id + '">Add</button>';
                    }
                }

                abcsetup.front_store.create.display_items[this.id] = this;
                html = html + '<tr class="' + row_class + '">\
                                    <td>' + this.sap_num + '</td>\
                                    <td>' + ((this.upc11 != null) ? this.upc11 : '') + '</td>\
                                    <td>' + ((this.abc_6_digit != null) ? this.abc_6_digit : '') + '</td>\
                                    <td>' + ((this.mfr_prod_code != null) ? this.mfr_prod_code : '') + '</td>\
                                    <td>' + ((this.mat_descr != null) ? this.mat_descr : '') + '</td>\
                                    <td>' + ((this.a_b_c_fineline != null) ? this.a_b_c_fineline.category_name : '') + '</td>\
                                    <td>' + ((this.mat_status != null) ? this.mat_status : '') + '</td>\
                                    <td nowrap>' + button + '</td>\
                                </tr>';
            });

            if (!response.data.length) {
                html = html + '<tr><td colspan="12" width="100%">No data found</td></tr>';
            }

            html = html + '</table></div>';
            $('#item-modal').find('#results').html(html);

            // Apply the highlighting
            var body = $('#item-modal').find('#results tbody');
            body.unhighlight();

            category = category ? $('#item-modal').find('#category option:selected').text() : '';
            body.highlight([identifier, mfr_prod_code, mat_descr, category]);
        });
    },

    /**
     *
     */
    findOneWsItem: function() {
        var gtin = $('#onews-modal').find('#gtin').val();
        var limit_vendor = '';

        abcsetup.front_store.create.one_ws_item = [];

        // No search params are specified
        if (gtin == '') {
            $('#onews-modal').find('#results').data('searchString', '').html('');
            return false;
        }

        // Come up with a unique search string to prevent duplicate search
        var searchString = gtin;
        if ($('#onews-modal').find('#results').data('searchString') == searchString) {
            return false;
        }

        // Remember the unique search string
        $('#onews-modal').find('#results').data('searchString', searchString);

        // We're not re-linking an item, limit the items to the current vendor
        if (abcsetup.front_store.create.front_store_id == 0) {
            limit_vendor = abcsetup.userOrg.id;
        }

        // Block the UI with a spinner
        abcsetup.blockUI(true);

        console.log('findOneWsItem',gtin);
        axios.get('/api/one_ws/search?column=gtin&value=' + gtin + '&limit_vendor=' + limit_vendor).then(response => {
            abcsetup.unblockUI();

            var html = '<div class="col-12">\
                            <table class="table table-striped table-sm table-bordered table-hover">\
                                <thead>\
                                    <tr>\
                                        <th>Description</th>\
                                        <th>Category Name</th>\
                                        <th>Unit of Measure</th>\
                                        <th>Shipping Method</th>\
                                    </tr>\
                                </thead>';

            var supplier_descr = '';
            var category = '';
            var uom = '';
            var shipping_method = '';
            var row_class = '';

            $(response.data).each(function() {
                var gtinData = this;
                if (gtinData.gtin == gtin) {
                    $(gtinData.one_ws_item_attr).each(function() {
                        if (this.col == 'supplier_descr') {
                            supplier_descr = this.val;
                        }
                        if (this.col == 'category') {
                            category = this.comment;
                        }
                        if (this.col == 'uom') {
                            uom = this.val;
                        }
                        if (this.col == 'shipping_method' && (this.val != '' && this.val != null)) {
                            shipping_method = this.val;
                        }
                    });
                }

                if (shipping_method == '' || shipping_method == null) {
                    $(gtinData.one_ws_item_attr).each(function() {
                        if (this.col == 'shipping_method' && (this.val != '' && this.val != null)) {
                            shipping_method = this.val;
                        }
                    });
                }
            });

            abcsetup.front_store.create.one_ws_item[gtin] = response.data;

            html = html + '<tr class="' + row_class + '">\
                                <td>' + ((supplier_descr != null) ? supplier_descr : '') + '</td>\
                                <td>' + ((category != null) ? category : '') + '</td>\
                                <td>' + ((uom != null) ? uom : '') + '</td>\
                                <td>' + ((shipping_method != null) ? shipping_method : '') + '</td>\
                                <td nowrap><button type="button" class="btn btn-primary btn-populate btn-sm" data-id="' + gtin + '">Populate Form</button></td>\
                            </tr>';

            if (!response.data.length) {
                html = html + '<tr><td colspan="12" width="100%">No data found</td></tr>';
            }

            html = html + '</table></div>';
            $('#onews-modal').find('#results').html(html);

            // Apply the highlighting
            var body = $('#onews-modal').find('#results tbody');
            //body.unhighlight();

            //body.highlight([identifier, mfr_prod_code, mat_descr, category]);
        });
    },

    /**
     * Add or re-link item
     */
    linkItem: function(id) {
        //alert(JSON.stringify(abcsetup.front_store.create.display_items[id]));

        // Check if the item already exists in the display item list
        if ($('.item_id[value="' + abcsetup.front_store.create.display_items[id].id + '"]').length > 0) {
            abcsetup.alerts.show('Item already exists', 'This item is already part of this Display');
            return false;
        }

        // Add a new item at the end of the display_item table
        if (abcsetup.front_store.create.front_store_id == 0) {
            abcsetup.front_store.create.front_store_id = abcsetup.front_store.create.appendItem(id);
        }

        abcsetup.front_store.create.updateDisplayTotals();
        abcsetup.front_store.create.updateDisplayUniqueItems();
        abcsetup.front_store.create.updateItemAttachment(id);
        abcsetup.front_store.create.createDisplayAttachment(id);

        // Hide and reset the modal
        // $('#item-modal input, #item-modal select').val('');
        // $('#item-modal').modal('hide');

    },

     /**
     * Populate form with 1worldsync item
     */
    populateForm: function(id) {
        //console.log(JSON.stringify(abcsetup.front_store.create.one_ws_item[id]));

        abcsetup.front_store.create.populateItem(id);
        abcsetup.form_manager.form.find('#onews_gtin').val($('#onews-modal').find('#gtin').val());

        // Hide and reset the modal
        $('#onews-modal input, #onews-modal select').val('');
        $('#onews-modal').modal('hide');
    },

    /**
     * Add a new item at the end of the display_item table
     */
    appendItem: function(id) {
        var item_id = $('table.new_display_items_table tr').length * -1
        var wac_total = abcsetup.front_store.create.display_items[id].wac * 1;

        // Update the rows HTML
        var html = '';
        html = '<tr class="new_item">';
        html = html + '<input type="hidden" id="item_id_'+id+'" name="display_items['+id+'][abc_item]" class="item_id" value="'+id+'">';
        html = html + '<td><button type="button" class="btn btn-sm btn-danger tooltips btn-remove-item" title="Remove Item" value="'+id+'"><i class="fas fa-trash"></i></button></td>';
        html = html + '<td>' + abcsetup.front_store.create.display_items[id].sap_num + '</td>';
        html = html + '<td>' + abcsetup.front_store.create.display_items[id].upc11 + '</td>';
        html = html + '<td>' + abcsetup.front_store.create.display_items[id].mfr_prod_code + '</td>';
        html = html + '<td>' + abcsetup.front_store.create.display_items[id].id + '<input type="hidden" name="display_items['+id+'][abc_item]" id="display_items['+id+'][abc_item]" value="'+abcsetup.front_store.create.display_items[id].id+'"></td>';
        html = html + '<td>' + abcsetup.front_store.create.display_items[id].a_b_c_fineline.category_name + '</td>';
        html = html + '<td>' + abcsetup.front_store.create.display_items[id].mat_descr + '</td>';
        html = html + '<td><input type="number" id="display_items['+id+'][qty]" name="display_items['+id+'][qty]" min="1" step="1" class="form-control bg-white form-control-sm col-4 qty" value="1"></input></td>';
        html = html + '<td class="wac_per_item currency">' + abcsetup.front_store.create.display_items[id].wac + '</td>';
        html = html + '<td class="wac_total">' + wac_total + '</td>';
        html = html + '<td class="item_attachment_'+id+'"></td>';
        html = html + '</tr>';

        // Append the new row
        $('#new_display_items_table').append(html);

        return item_id;
    },

    /**
     * Populate 1worldsync item into the form
     */
    populateItem: function(id) {

        console.log('populateItem',abcsetup.front_store.create.one_ws_item[id]);

        $(abcsetup.front_store.create.one_ws_item[id]).each(function() {
            var gtinData = this;
            $(gtinData.one_ws_item_attr).each(function() {
                if (this.col.match(/^rx\./)) {
                    // this column is only for rx_items - ignore
                    return;
                }
                else if (this.col.match(/^fs\./)) {
                    this.col = this.col.replace(/^fs\./,'');
                }
                if (this.col != 'brand' && this.col != 'category' && this.col != 'country_origin') {
                    if (this.val != '' && this.val != null) {
                        $("#"+this.col).val(this.val).trigger('change');
                        if (this.col == 'inner_gtin') {
                            $("#inners").val("Y").trigger("change");
                        }
                    }
                }
                else if (this.col == 'country_origin') {
                    var select_right = $("#"+this.col);
                    var this_shuttlebox = select_right.closest("div.shuttlebox");
                    var select_left = this_shuttlebox.find("select.shuttlebox-left");
                    var value = this.val;
                    if (value) {
                        select_right.append(select_left.find("option[value="+value+"]").prop('selected','selected'));
                        select_left.find("option[value="+value+"]").remove();
                    }
                }
                else {
                    $(".1ws_"+this.col).remove();
                    var value = this.val != null && this.val != '' ? this.val : this.comment;
                    $("#"+this.col).val(value).after('<span class="small inForm text-danger errorMsg 1ws_'+this.col+'">Unable to map this 1WorldSync attribute value: '+value+'</span>');;
                }
            });
        });

    },

    /**
     * Update the display totals
     */
    updateDisplayTotals: function() {
        var display_num_total_items = 0;
        var display_cost = 0;
        $(".qty").each(function() {
            var qty = parseFloat($(this).val());
            var wac_per_item = parseFloat($(this).closest("tr").find(".wac_per_item").html());
            display_cost += qty*wac_per_item;
            display_num_total_items += qty;
        });
        $("#display_cost").val(Math.round(display_cost*100)/100);
        $("#display_num_total_items").val(display_num_total_items);
    },

    /**
     * Update the display unique items
     */
    updateDisplayUniqueItems: function() {
        var display_num_unique_items = 0;
        $(".qty").each(function() {
            display_num_unique_items += 1;
        });
        $("#display_num_unique_items").val(display_num_unique_items);
    },

    updateItemAttachment: function(id) {
        let html_attachment = '';
        axios.get('/api/front_store/get_display_item_attachment/' + id).then(response => {
            $(response.data).each(function() {
                let url = '/attachments/preview/' + this.upload_uuid;
                let title = this.type_name;
                html_attachment = html_attachment + '<a href="' + url + '" class="" data-toggle="lightbox" data-title="' + title + '" data-footer="<button type=\'button\' class=\'btn btn-secondary toggle-size-btn\' data-last-height=\'auto\' data-last-width=\'auto\'>Toggle Size</button><a href=' + url + ' class=\'btn btn-primary\'>Download</a>" data-type="url" data-disable-external-check="true" data-width="' + abcsetup.attachments.width + '" data-height="' + abcsetup.attachments.height + '" data-alwaysShowClose="true" title="Preview">' + title + '</a><br>';
            });

            $(".item_attachment_"+id).html(html_attachment);
        });
    },

    createDisplayAttachment: function(id) {
        axios.get('/api/front_store/create_display_attachment/' + id).then(response => {
            $(response.data).each(function() {
                if (this.upload_uuid != undefined) {
                    let button = '<a id="item_attachment_'+id+'" href="/attachments/download/' + this.upload_uuid + '" class="col-12 col-md-3 text-center attachment-link-thumb" target="_blank">\
                                    <input type="hidden" name="file_attachments[]" value="' + this.id + '">\
                                    <img src="/attachments/thumb/' + this.upload_uuid + '">\
                                    <br>';

                    if (this.type_name) {
                        button = button + this.type_name + '<br>' + this.item_mat_descr + ' (SAP #: ' + this.item_sap_num + ')<br>';
                    }

                    button = button + '<small>' + this.filename + '</small>\
                                                            <i class="far fa-trash-alt text-danger delete-attachment" title="Delete Attachment" data-type="'+this.type+'" data-id="'+this.id+'"></i>\
                                                        </a>';

                    $('#attachments .existing .row').append(button);

                    if (this.type == 'msds_sheet') {
                        $('#sds_waiver').val('Y');
                        $("#sds_waiver").trigger("change");
                    }
                    else if (this.type == 'sds_waiver') {
                        $('#sds_waiver').val('N');
                        $("#sds_waiver").trigger("change");
                    }
                    $('button#'+this.type).removeClass('required btn-danger').show();
                }
            });
        });
    },

    deleteDisplayItemAttachment: function(id) {
        $("#item_attachment_"+id).remove();
    },

    /**
     * Auto save the item form
     */
    _autoSave: function () {
        /*
        $('form.front-store-item').append('<input type="hidden" class="tmp-action" name="form_action" value="update">');
        axios.post('/front_store/' + abcsetup.item.id + '?auto=t', $('form.front-store-item').serialize()).then(response => {
            $('form.front-store-item').find('.tmp-action').remove();
        });
        */
    },

    uploadDoneAfterAutoAppend() {
        if (abcsetup.uploader.button.closest('#images_tab').length > 0 && $(abcsetup.uploader.button).data('type') !== 'glamour_shot') {
            $(abcsetup.uploader.button)
                .closest('.attachments')
                .find('.attachment-link-thumb')
                .removeClass(['col-12', 'col-md-3']);
        }
    }
}
